import { backendService, backendServicePublic } from "services"

export const getCompanies = async () => {
    return await backendService.get(`/company`)
}

export const getCompaniesPaged = async (page, perPage) => {
    return await backendService.get(`/company/paged?page=${page}&per_page=${perPage}`)
}

export const getCompanyById = async (id) => {
    return await backendService.get(`/company/${id}`)
}

export const getCompanyBySlug = async (slug) => {
    return await backendServicePublic.get(`/company/by-slug/${slug}`)
}

export const getCompanyShortBySlug = async (slug) => {
    return await backendServicePublic.get(`/company/short-data-by-slug/${slug}`)
}

export const getMapCompanyBySlug = async (slug) => {
    return await backendService.get(`/company/map-by-slug/${slug}`)
}

export const getCompanyRolesBySlug = async (slug) => {
    return await backendService.get(`/company/roles-by-slug/${slug}`)
}

export const addCompany = async (data) => {
    return await backendService.post('/company', data)
}

export const editCompany = async (id, data) => {
    return await backendService.put(`/company/${id}`, data)
}

/**
 * LAYER 1 OF PROTECTION - Frontend Whitelist
 *
 * Edit company profile with limited fields
 * Only allows: name, corporateName, description, size, income, industry, domains
 * Protected fields like CNPJ, signedPlan, roles, etc. are NOT sent to the backend
 *
 * @param {string} id - Company ID
 * @param {object} data - Company profile data (will be filtered by caller)
 * @returns {Promise} - API response
 */
export const editCompanyProfile = async (id, data) => {
    return await backendService.put(`/company/${id}/profile`, data)
}

export const deleteCompany = async (id) => {
    return await backendService.delete(`/company/${id}`)
}

export const getCompaniesByPartner = async (tenantId) => {
    return await backendService.get(`/company/by-partner/${tenantId}`)
}

export const getCompaniesByPartnerPaged = async (tenantId, page, perPage) => {
    return await backendService.get(`/company/by-partner/${tenantId}?page=${page}&per-page=${perPage}`)
}

export const createCompany = async (data, idOnboard) => {
    return await backendServicePublic.post(`/company/onboarding/${idOnboard}`, data)
}

export const editCompanyPlan = async (slug, data) => {
    return await backendServicePublic.put(`/company/onboarding/${slug}`, data)
}

export const getPresetPlan = async (slug) => {
    return await backendServicePublic.get(`/company/site/preset-plan/${slug}`,)
}